<template>
    <div>
        <div class="d-flex flex-wrap align-items-center mb-2" style="gap: 10px;">
            <div class="d-flex flex-fill" style="gap: 7px;">
                <HelpPopup button-component="b-button" label="Actions" :muted="false" icon=""
                    popover-custom-class="actions-popover multi-col glass-pane"
                    button-custom-class="m-0 bg-primary text-white" :popover-offset="205" @show="showingMenu = true"
                    @hide="showingMenu = false">
                    <template #label>
                        <i :class="{ 'fa fa-chevron-down fa-fw mr-1': true, 'fa-rotate-180': showingMenu }"
                            style="transition: all .2s;"></i>
                        <strong>Actions</strong>
                    </template>
                    <template #default="{ close }">
                        <div class="mt-2">
                            <div>
                                <h6>
                                    <i class="fa fa-comment-alt" />
                                    Messaging
                                </h6>
                                <ul>
                                    <!--<b-dropdown-item @click="close(); changeOutboundOptOut(outboundCallOptOut)">
                                        {{ outboundCallOptOut ? "Opt Into Refill Calls" : "Opt Out Of Refill Calls" }}
                                    </b-dropdown-item>-->
                                    <b-dropdown-item @click="close(); changeTextOptOut(!patient.textMessageOptOutDate)">
                                        {{
                                            patient.textMessageOptOutDate ?
                                                "Opt Into Text Messages" :
                                                "Opt Out Of Text Messages"
                                        }}
                                    </b-dropdown-item>
                                    <b-dropdown-item v-if="!isNpcTextDisabled" @click="close(); sendNpcText()">
                                        Send Npc Text...
                                    </b-dropdown-item>
                                    <b-dropdown-item v-if="!isRefillTextDisabled" @click="close(); sendRefillText()">
                                        Send Refill Text...
                                    </b-dropdown-item>
                                    <b-dropdown-item v-if="!isRxRequestDeniedTextDisabled" @click="close(); sendRxRequestDeniedText()">
                                        Send Rx Request Denied Text...
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="close(); showPapTextModal();">
                                        Send Pap Text...
                                    </b-dropdown-item>
                                    <b-dropdown-item v-if="!isPharmacyInfoTextDisabled" @click="close(); $bvModal.show('pharmacy-text-modal')">
                                        Send Pharmacy Info Text...
                                    </b-dropdown-item>
                                    <b-dropdown-item v-if="!isAwaitingInsuranceTextDisabled" @click="close(); sendAwaitingInsuranceText()">
                                        Send Awaiting Insurance Text...
                                    </b-dropdown-item>
                                    <b-dropdown-item @click="close(); StartIRSReport()">
                                        Send IRS Report...
                                    </b-dropdown-item>

                                    <template v-if="filteredAvailableCustomTextTemplates.length">
                                        <b-dropdown-item id="custom-text-msg-action-item"
                                            :class="{ 'open': showingCustomTextSubMenu }">
                                            <div class="d-flex align-items-center">
                                                <div class="flex-fill">
                                                    Send Custom Text Message
                                                </div>
                                                <i class="fa fa-chevron-right pull-right" />
                                            </div>
                                        </b-dropdown-item>
                                        <b-popover target="custom-text-msg-action-item" triggers="hover"
                                            custom-class="actions-popover glass-pane sub" placement="righttop"
                                            @show="showingCustomTextSubMenu = true"
                                            @hide="showingCustomTextSubMenu = false">
                                            <h6>Custom Text Messages</h6>
                                            <ul>
                                                <b-dropdown-item v-for="t in filteredAvailableCustomTextTemplates"
                                                    :key="t.id"
                                                    @mousedown.native.stop.prevent="close(); startCustomTextSend(t)">
                                                    <div style="white-space: normal;">
                                                        {{ t.name }}
                                                    </div>
                                                </b-dropdown-item>
                                            </ul>
                                        </b-popover>
                                    </template>
                                </ul>
                            </div>
                            <div>
                                <div class="mb-3">
                                    <h6>
                                        <i class="fa fa-prescription" />
                                        Prescriptions
                                    </h6>
                                    <ul>
                                        <b-dropdown-item @click="close(); StartRxTransfer()">
                                            Start Transfer...
                                        </b-dropdown-item>
                                        <b-dropdown-item v-if="hasBulkTransferPermission" @click="close(); startBulkExternalTransfer()">
                                            Bulk External Transfer...
                                        </b-dropdown-item>
                                        <b-dropdown-item @click="close(); $bvModal.show('new-rx-request-fax')">
                                            Request New Rx...
                                        </b-dropdown-item>
                                        <b-dropdown-item @click="close(); openMedSyncEnrollmentModal()">
                                            Enroll in MedSync...
                                        </b-dropdown-item>
                                        <!-- <b-dropdown-item @click="close(); openCovidModal()">
                                            Create COVID Test Script...
                                        </b-dropdown-item> -->
                                    </ul>
                                </div>
                                <div class="mb-3">
                                    <h6>
                                        <i class="fa fa-truck" />
                                        Ordering
                                    </h6>
                                    <ul>
                                        <b-dropdown-item @click="close(); $bvModal.show('online-orders-modal')">
                                            Online Orders...
                                        </b-dropdown-item>
                                        <b-dropdown-item @click="close(); paymentMethodsModal()">
                                            Payment Methods...
                                        </b-dropdown-item>
                                    </ul>
                                </div>

                                <div>
                                    <h6>
                                        <i class="fa fa-stream" />
                                        More
                                    </h6>
                                    <ul>
                                        <b-dropdown-item @click="close(); openNewConsultationModal()">
                                            New Consultation...
                                        </b-dropdown-item>
                                        <b-dropdown-item @click="close(); openCreateCaseModal()">
                                            New Case...
                                        </b-dropdown-item>
                                        <b-dropdown-item @click="close(); resetPatientAppModal()"
                                            v-if="patient.patientAppUserName != null">
                                            Reset Patient App Password...
                                        </b-dropdown-item>
                                        <b-dropdown-item @click="close(); $bvModal.show('duplicate-modal')">
                                            Duplicate Patient...
                                        </b-dropdown-item>
                                        <b-dropdown-item v-if="hasOldPortal" :href="oldPortalLink" target="_blank">
                                            View in Old Portal...
                                        </b-dropdown-item>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </template>
                </HelpPopup>

                <b-button v-b-modal.patient_documents_modal class="m-0" variant="info" size="sm">
                    <i class="far fa-lg fa-file-alt mr-1"></i>
                    Documents
                </b-button>
            </div>

            <div class="status-indication d-flex">
                <HelpPopup icon="fa fa-fw fa-check-circle" title="Awaiting PV1"
                    :label="errorAwaitingPV1 ? '' : awaitingPV1.length" :muted="!awaitingPV1.length"
                    popover-custom-class="actions-popover glass-pane" placement="bottom" :loading="loadingAwaitingPV1"
                    :variant="errorAwaitingPV1 ? 'danger' : null">
                    <h6 class="mt-2">
                        <i class="fa fa-check-circle" />
                        Awaiting PV1
                    </h6>

                    <div v-if="errorAwaitingPV1" class="text-center text-danger p-3 font-weight-bolder">
                        Error loading prescriptions awaiting PV1 for patient<br>
                        {{ errorAwaitingPV1 }}
                    </div>
                    <template v-else>
                        <div v-if="!awaitingPV1.length" class="text-center text-muted p-3">
                            No prescriptions awaiting PV1 for patient
                        </div>

                        <ul>
                            <b-dropdown-item v-for="i in awaitingPV1" :to="{
                                name: hasPV1Permission ? 'PV1' : 'PrescriptionDetails'
                                , params: {
                                    storeID: i.storeID,
                                    rxNumber: i.rxNumber,
                                    rfNumber: i.rfNumber
                                }
                            }" :key="i.rxID">
                                <div style="line-height: 1.4">
                                    <div>
                                        <span class="rxId">
                                            {{ i.rxID }}
                                        </span>
                                        &middot;
                                        {{ i.drugName }}
                                    </div>
                                    <div class="text-muted">
                                        <small>
                                            {{ i.fillDate | formatDate("L") }}
                                            <template v-if="i.programName">
                                                &middot;
                                                {{ i.programName }}
                                            </template>
                                            <strong v-if="!!i.dispenseErrorId" class="text-danger">
                                                <i class="fa fa-exclamation-circle" />
                                                {{ dispenseErrorLabel }}
                                            </strong>
                                        </small>
                                    </div>
                                </div>
                            </b-dropdown-item>
                        </ul>
                    </template>
                </HelpPopup>

                <HelpPopup icon="fa fa-fw fa-shopping-cart" title="Available to Order"
                    :label="errorAvailableToOrder ? '' : availableToOrder.length" :muted="!availableToOrder.length"
                    popover-custom-class="actions-popover glass-pane" placement="bottom"
                    :loading="loadingAvailableToOrder" :variant="errorAvailableToOrder ? 'danger' : null">
                    <h6 class="mt-2">
                        <i class="fa fa-shopping-cart" />
                        Available to Order
                    </h6>

                    <div v-if="errorAvailableToOrder" class="text-center text-danger p-3 font-weight-bolder">
                        Error loading available to order for patient<br>
                        {{ errorPendingBilling }}
                    </div>
                    <template v-else>
                        <div v-if="!availableToOrder.length" class="text-center text-muted p-3">
                            No prescriptions available to order for patient
                        </div>

                        <ul>
                            <b-dropdown-item v-for="i in availableToOrder" :to="{
                                name: 'PrescriptionDetails'
                                , params: {
                                    storeID: i.storeID,
                                    rxNumber: i.rxNumber,
                                    rfNumber: i.rfNumber
                                }
                            }" :key="i.rxID">
                                <div style="line-height: 1.4">
                                    <div>
                                        <span class="rxId">
                                            {{ i.rxID }}
                                        </span>
                                        &middot;
                                        {{ i.drugName }}
                                    </div>
                                    <div class="text-muted">
                                        <small>
                                            {{ i.fillDate | formatDate("L") }}
                                            <template v-if="i.programName">
                                                &middot;
                                                {{ i.programName }}
                                            </template>
                                            <strong v-if="!!i.dispenseErrorId" class="text-danger">
                                                <i class="fa fa-exclamation-circle" />
                                                {{ dispenseErrorLabel }}
                                            </strong>
                                        </small>
                                    </div>
                                </div>
                            </b-dropdown-item>
                        </ul>
                    </template>
                </HelpPopup>

                <HelpPopup icon="fa fa-fw fa-dollar-sign" title="Pending Billing"
                    :label="errorPendingBilling ? '' : pendingBilling.length" :muted="!pendingBilling.length"
                    popover-custom-class="actions-popover glass-pane" placement="bottom"
                    :loading="loadingPendingBilling" :variant="errorPendingBilling ? 'danger' : null">
                    <h6 class="mt-2">
                        <i class="fa fa-money-bill" />
                        Pending Billing
                    </h6>

                    <div v-if="errorPendingBilling" class="text-center text-danger p-3 font-weight-bolder">
                        Error loading pending billing for patient<br>
                        {{ errorPendingBilling }}
                    </div>
                    <template v-else>
                        <div v-if="!pendingBilling.length" class="text-center text-muted p-3">
                            No prescriptions pending billing for patient
                        </div>

                        <ul>
                            <b-dropdown-item v-for="i in pendingBilling" :to="{
                                name: 'PrescriptionDetails'
                                , params: {
                                    storeID: i.storeID,
                                    rxNumber: i.rxNumber,
                                    rfNumber: i.rfNumber
                                }
                            }" :key="i.rxID">
                                <div style="line-height: 1.4">
                                    <div>
                                        <span class="rxId">
                                            {{ i.rxID }}
                                        </span>
                                        &middot;
                                        {{ i.drugName }}
                                    </div>
                                    <div class="text-muted">
                                        <small>
                                            {{ i.fillDate | formatDate("L") }}
                                            <template v-if="i.programName">
                                                &middot;
                                                {{ i.programName }}
                                            </template>
                                            <strong v-if="!!i.dispenseErrorId" class="text-danger">
                                                <i class="fa fa-exclamation-circle" />
                                                {{ dispenseErrorLabel }}
                                            </strong>
                                        </small>
                                    </div>
                                </div>
                            </b-dropdown-item>
                        </ul>
                    </template>
                </HelpPopup>

                <HelpPopup icon="fa fa-fw fa-check-double" title="Open Assigned Tasks"
                    :label="errorOpenAssignedTasks ? '' : openAssignedTasks.length" :muted="!openAssignedTasks.length"
                    popover-custom-class="actions-popover glass-pane" placement="bottom"
                    :loading="loadingOpenAssignedTasks" :variant="errorOpenAssignedTasks ? 'danger' : null">
                    <h6 class="mt-2">
                        <i class="fa fa-check-double" />
                        Open Assigned Tasks
                    </h6>

                    <div v-if="errorOpenAssignedTasks" class="text-center text-danger p-3 font-weight-bolder">
                        Error loading assigned tasks for patient<br>
                        {{ errorOpenAssignedTasks }}
                    </div>
                    <template v-else>
                        <div v-if="!openAssignedTasks.length" class="text-center text-muted p-3">
                            No open assigned tasks for patient
                        </div>

                        <ul>
                            <b-dropdown-item v-for="i in openAssignedTasks" :to="{
                                name: 'Tasks'
                                , params: {
                                    taskId: i.id
                                }
                            }" :key="i.id">
                                <div style="line-height: 1.4">
                                    <div>
                                        {{ i.title }}
                                    </div>
                                    <div class="text-muted">
                                        <small>
                                            {{ i.created | formatDate("L", false) }}
                                            <template v-if="i.prescriptions?.length">
                                                &middot;
                                                {{ i.prescriptions[0].storeID + "-" + i.prescriptions[0].rxNumber + "-"
                                                    + i.prescriptions[0].rfNumber }}
                                            </template>
                                        </small>
                                    </div>
                                </div>
                            </b-dropdown-item>
                        </ul>
                    </template>
                </HelpPopup>
            </div>

            <b-modal id="SendPapTextModal" centered title="Send PAP Text" ok-title="Send Text" @ok="sendPapText">
                <SearchComponent v-model="selectedStoreForPap" label="Store (optional)" search-u-r-l="/Store"
                    :params="{ active: true }" clearable prepopulate />

                <SearchComponent v-model="selectedProgramForPap" label="Program (optional)" search-u-r-l="/Program"
                    :params="{ active: true }" clearable prepopulate />

                <SearchComponent v-model="selectedDrugForPap" label="Drug (optional)" search-u-r-l="/Drug"
                    :params="{ onlyActive: true, allSources: true }" clearable />
            </b-modal>

            <b-modal id="pharmacy-text-modal" title="Send Pharmacy Info Text" @ok="sendPharmacyInfoText">
                <search-component v-model="storeInfo" search-u-r-l="/store" :params="{active: true}" prepopulate />
            </b-modal>

            <b-modal id="irsReportModal" hide-footer size="lg" title="Send IRS Report">
                <IRSReportComponent :patient="patient" />
            </b-modal>

            <b-modal id="rxTransferModal" hide-footer size="lg" title="Rx Transfer">
                <RxTransferModalComponent :patient="patient" @complete="$bvModal.hide('rxTransferModal')" />
            </b-modal>

            <b-modal id="bulk-external-transfer-modal" hide-footer size="xl" title="Bulk External Transfer">
                <BulkTransferOutComponent
                    :show-filters="false"
                    :patient="patient"
                    @transfer-completed="$bvModal.hide('bulk-external-transfer-modal')" />
            </b-modal>

            <FaxToPhysicianFormModal modal-id="new-rx-request-fax" :patient="patient"
                :form-type="faxFormTypeRequestEnum.NewRxRequest" @saved="$emit('change-follow-up-cases')" />

            <!-- <b-modal id="createCovidTestScript" ref="createCovidTestScript" size="lg"
                title="Create Script for COVID Tests" hide-footer>
                <SearchComponent v-model="covidStore" label="Pharmacy" :option-label="storeLabel" search-u-r-l="/Store"
                    clearable prepopulate></SearchComponent>
                <b-dropdown id="insurance-selection" variant="success" :text="this.covidPlan.toString()">
                    <b-dropdown-item v-for="plan in this.covidPlans" :key="plan.patientPlan.id">
                        {{ plan.toString() }}
                    </b-dropdown-item>
                </b-dropdown>
                <b-button block class="my-0" variant="success" :disabled="covidDisabled" @click="createCovidScript">
                    Create Script
                </b-button>
            </b-modal> -->

            <OnlineOrdersModal :patient="patient" />

            <b-modal id="PaymentMethodModalMaintenance" hide-footer size="xl" title="Payment Methods">
                <PatientPaymentMethodsModal :patient="patient" />
            </b-modal>

            <b-modal id="newConsultationModal" hide-footer no-close-on-backdrop size="lg" title="New Consultation">
                <label>Store: *</label>
                <SearchComponent v-model="newConsultationStore" prepopulate search-u-r-l="/Store" :params="{active: true}" :hide-label="true" />
                <NewConsultationFormComponent v-if="newConsultationStore.id" :patient="patient"
                    :store="newConsultationStore" @updateList="updateConsultationsList" />
            </b-modal>

            <b-modal id="duplicate-modal" title="Create Patient Merge Request" @ok="addMergeQueue" no-fade
                @show="showDuplicateModal">
                <search-component v-model="mergeRequestTargetPatient" search-u-r-l="/patient" prepopulate
                    label="Target Patient" />

                <PatientRecentlyViewed @change="mergeRequestTargetPatient = $event"
                    :selected="mergeRequestTargetPatient" :hide-list="hideMergeRecentList" :disable-patient="patient">
                    <template #title>
                        <a href="#" @click.prevent="hideMergeRecentList = !hideMergeRecentList">
                            <i :class="{ 'fa': true, 'fa-chevron-right': true, 'fa-rotate-90': !hideMergeRecentList }"
                                aria-hidden="true" style="transition: all .2s;"></i>
                            Recently Viewed Patients
                        </a>
                    </template>
                </PatientRecentlyViewed>

                <div class="mt-3">
                    <label for="merge-request-notes">Notes <small class="text-muted">(optional)</small></label>
                    <b-form-textarea id="merge-request-notes" v-model="mergeRequestNotes"
                        class="textarea-autosize"
                        placeholder="Explain the reason for this merge request..." />
                </div>
            </b-modal>

            <b-modal id="ResetPatientAppModal" title="Reset Patient App" size="xl" hide-footer hide-header-close>
                <ResetPatientAppPasswordComponent :patient="patient" @close="hidePatientAppModal" />
            </b-modal>

            <b-modal id="med-sync-enrollment-modal" size="xl" title="MedSync Enrollment" hide-footer>
                <MedSyncEnrollmentModal :patient="patient" :prescriptions="prescriptions" @completed="onMedSyncEnrollmentCompleted" />
            </b-modal>

            <PatientDocumentsModal :patient="patient" />

            <CreateCaseModal
                modal-id="patient-actions-create-case-modal"
                :patient="patient"
                :prescriptions="prescriptions"
                @saved="onCaseSaved" />

            <b-modal :title="activeCustomTextTemplate?.name" :visible="!!activeCustomTextTemplate" no-fade
                ok-title="Send Text" @ok="sendCustomText" @hidden="activeCustomTextTemplate = null">
                <CustomTextMessageTemplateSend v-if="activeCustomTextTemplate" v-model="activeCustomTextTemplate"
                    :patient="patient" />
            </b-modal>

            <b-modal id="npc-text-final-warning-modal" title="Confirm Send Text Message" centered
                @shown="startNpcFinalWarningCountdown" @hidden="clearNpcFinalWarningCountdown" @ok="confirmNpcFinalWarning">
                <template #default>
                    <div class="msg-bubble">{{ npcTextPreview }}</div>
                    <b-alert show variant="danger" class="mt-3 mb-0">
                        <p class="font-weight-bold mb-2">
                            FINAL WARNING: There are no prescriptions ready for checkout with this patient.
                        </p>
                        <p class="mb-0">
                            Sending this text may confuse the patient as they have nothing available to order.
                        </p>
                    </b-alert>
                    <p v-if="npcFinalWarningCountdown > 0" class="text-muted font-weight-bold mt-3 mb-0">
                        Please wait {{ npcFinalWarningCountdown }} seconds before sending...
                    </p>
                </template>
                <template #modal-footer="{ ok, cancel }">
                    <b-button variant="secondary" @click="cancel()">Cancel</b-button>
                    <b-button variant="danger" :disabled="npcFinalWarningCountdown > 0" @click="ok()">
                        Send Anyway
                    </b-button>
                </template>
            </b-modal>
        </div>
    </div>
</template>

<script lang="ts">
import { Patient } from '@/models/Patient';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import PatientDocumentsModal from './PatientDocumentsModal.vue';
import ResetPatientAppPasswordComponent from './ResetPatientAppPasswordComponent.vue';
import OnlineOrdersModal from './OnlineOrdersModal.vue';
import PatientPaymentMethodsModal from './PatientPaymentMethodsModal.vue';
import NewConsultationFormComponent from '../Consultation/NewConsultationFormComponent.vue';
import PatientRecentlyViewed from './PatientRecentlyViewed.vue';
import SearchComponent from '../SearchComponent.vue';
import FaxToPhysicianFormModal from '../Prescription/FaxToPhysicianFormModal.vue';
import RxTransferModalComponent from '../RxTransfer/RxTransferModalComponent.vue';
import BulkTransferOutComponent from '../Transfer/BulkTransferOutComponent.vue';
import IRSReportComponent from '../EmbeddedReports/IRSReportComponent.vue';
import HelpPopup from '../HelpPopup.vue';
import axios from 'axios';
import { NotificationOptions } from '@/util/NotificationOptionsPresets';
import { BvModalEvent } from 'bootstrap-vue';
import { Store } from '@/models/Store';
import { Prescription } from '@/models/Prescription';
import { FaxType } from '@/models/PrescriberFollowUpCase';
import { Program } from '@/models/Program';
import { CustomTextMessageTemplate, DefaultTemplates } from '@/models/CustomTextMessageTemplate';
import CustomTextMessageTemplateSend from './CustomTextMessageTemplateSend.vue';
import { Drug } from '@/models/Drug/Drug';
import { OrderLabelData } from '@/models/OrderLabelData';
import { UserTask } from "@/models/UserTask";
import MedSyncEnrollmentModal from './MedSyncEnrollmentModal.vue';
import CreateCaseModal from '@/components/Cases/CreateCaseModal.vue';
import { TextMessageTemplates } from '@/models/TextMessageTemplates';

const linkExample: string = "https://link.com/ex";
const dateExample: string = "Monday, June 5";

@Component({
    components: {
        PatientDocumentsModal,
        ResetPatientAppPasswordComponent,
        OnlineOrdersModal,
        PatientPaymentMethodsModal,
        NewConsultationFormComponent,
        SearchComponent,
        PatientRecentlyViewed,
        FaxToPhysicianFormModal,
        RxTransferModalComponent,
        BulkTransferOutComponent,
        IRSReportComponent,
        HelpPopup,
        CustomTextMessageTemplateSend,
        MedSyncEnrollmentModal,
        CreateCaseModal
    }
})
export default class PatientActionsBar extends Vue {

    @Prop({ required: true }) protected patient!: Patient;
    @Prop({ default: [] }) protected prescriptions!: Prescription[];

    // noinspection JSUnusedGlobalSymbols
    mounted() {
        this.handlePatientChange();
        this.getAvailableCustomTextTemplates();
        this.fetchDispenseErrorLabel();
        this.getTextMessageTemplates();
    }

    @Watch("patient")
    handlePatientChange(newPatient?: Patient, oldPatient?: Patient) {
        if (newPatient && newPatient?.id === oldPatient?.id) return;
        this.getAwaitingPV1();
        this.getAvailableToOrder();
        this.getPendingBilling();
        this.getOpenAssignedTasks();
    }

    protected showingMenu = false;

    //Text Opt Out
    async changeTextOptOut(shouldOptOut: boolean) {
        try {
            await axios.post(`/Patient/${this.patient.id}/${shouldOptOut}/ChangeTextMessageOptOut`);

            this.$notification(NotificationOptions.success(`Updated text message status for patient: optted ${shouldOptOut ? "out" : "in"}`));

            const updatedPatientResponse = await axios.get(`/Patient/${this.patient.id}`);
            const updatedPatient = Object.assign(new Patient(), updatedPatientResponse.data);

            this.$emit('update-patient', updatedPatient);
        } catch (err) {
            this.$notification(NotificationOptions.error(err));
        }
    }

    //Refill Calls
    // private outboundCallOptOut = false;

    // async getOutboundOptOutStatus() {
    //     try {
    //         const response = await axios.get<boolean>(`/Patient/${this.patient.id}/GetOutboundOptStatus`);
    //         this.outboundCallOptOut = response.data;
    //     } catch (error) {
    //         console.error("Error Getting Opt Status", error);
    //     }
    // }

    // async changeOutboundOptOut(status: boolean) {
    //     try {
    //         await axios.post(
    //             `/Patient/${this.patient.id}/${status}/ChangeOutboundOptStatus`,
    //         );
    //         this.outboundCallOptOut = status;
    //         this.$notification(NotificationOptions.success("Updated refill call opt out status"));
    //     } catch (error) {
    //         console.error("Error Changing Opt Status", error);
    //         this.$notification(NotificationOptions.error(error));
    //     }
    // }

    //NPC Text
    async sendNpcText() {
        try {
            const previewResponse = await axios.get(`/api/patient/${this.patient.id}/preview/NpcText`)
            const preview = previewResponse.data;
            const h = this.$createElement;
            let messageNodes = [
                h('div', { class: "msg-bubble" }, preview)
            ];

            // Check if there are any prescriptions ready for checkout with claims
            const scriptsReadyForCheckout = this.availableToOrder.filter(p => p.patientPay != null);

            const prescriptionsRequiringPV1 = this.prescriptions?.filter(p => p.isPV1Required || this.awaitingPV1.some(a => a.rxID === p.rxID) );

            if (prescriptionsRequiringPV1?.length) {
                const h = this.$createElement;

                const promptMessage = `Are you sure you want to send the text?
                    PV1 is required on ${prescriptionsRequiringPV1?.length === 1 ? "this prescription:" : "these prescriptions:"}`;

                const alertContent = [
                    h('p', { class: 'font-weight-bold mb-2' }, promptMessage),
                    ...prescriptionsRequiringPV1.map(p => h('p', { class: 'mb-1' }, `${p.rxID}: ${p.drugName}`))
                ];

                messageNodes.push(h('b-alert', { props: { show: true, variant: 'primary' }, class: 'mt-3 mb-0' }, alertContent));

                const confirm = await this.$bvModal.msgBoxConfirm(messageNodes, {
                    title: 'Confirm Send Text Message',
                    okVariant: 'primary',
                    centered: true,
                    okTitle: "Send",
                    scrollable: true,
                });
                if (!confirm) return;
            } else if (scriptsReadyForCheckout.length === 0) {
                // First warning: No scripts ready for checkout
                const warningMessageNodes = [
                    h('div', { class: "msg-bubble" }, preview),
                    h('b-alert', { props: { show: true, variant: 'warning' }, class: 'mt-3 mb-0' }, [
                        h('strong', {}, 'Warning: There are no prescriptions ready for checkout. Are you sure you want to send this text?')
                    ])
                ];

                const firstConfirm = await this.$bvModal.msgBoxConfirm(warningMessageNodes, {
                    title: 'Confirm Send Text Message',
                    okVariant: 'primary',
                    centered: true,
                    okTitle: "Continue...",
                    cancelTitle: "Cancel"
                });

                if (!firstConfirm) return;

                // Second warning: Strong confirmation with delay
                const secondConfirm = await this.showNpcFinalWarningModal(preview);

                if (!secondConfirm) return;
            } else {
                // Add standard confirmation when PV1 is not required and scripts are ready
                const confirm = await this.$bvModal.msgBoxConfirm(
                    messageNodes,
                    {
                        title: 'Confirm Send Text Message',
                        okVariant: 'primary',
                        centered: true,
                        okTitle: "Send",
                    }
                );
                if (!confirm) return;
            }

            const endpoint = `/api/patient/sendNpcText`;

            await axios.post(endpoint, this.patient);

            this.$notification(NotificationOptions.success("Message Sent"));
        } catch (err) {
            this.$notification(NotificationOptions.error(err));
        }
    }

    //Refill Text
    async sendRefillText() {
        try {
            const previewResponse = await axios.get(`/api/patient/${this.patient.id}/preview/RefillText`)
            const preview = previewResponse.data;
            const h = this.$createElement;
            let messageNodes = [
                h('div', { class: "msg-bubble" }, preview)
            ];

            const confirm = await this.$bvModal.msgBoxConfirm(
                messageNodes,
                {
                    title: 'Confirm Send Text Message',
                    okVariant: 'primary',
                    centered: true,
                    okTitle: "Send",
                }
            );
            if (!confirm) return;

            const endpoint = "/api/patient/sendRefillText";
            await axios.post(endpoint, this.patient);

            this.$notification(NotificationOptions.success("Message Sent"));
        } catch (err) {
            this.$notification(NotificationOptions.error(err));
        }
    }

    //Rx Denied Text
    async sendRxRequestDeniedText() {
        try {
            const previewResponse = await axios.get(`/api/patient/${this.patient.id}/preview/RxRequestDeniedText`)
            const preview = previewResponse.data;
            const h = this.$createElement;
            let messageNodes = [
                h('div', { class: "msg-bubble" }, preview)
            ];
            const confirm = await this.$bvModal.msgBoxConfirm(
                messageNodes,
                {
                    title: 'Confirm Send Text Message',
                    okVariant: 'primary',
                    centered: true,
                    okTitle: "Send",
                }
            );
            if (!confirm) return;

            await axios.post("/api/Patient/SendRxRequestDeniedText", this.patient);
            this.$notification(NotificationOptions.success("Message Sent"));
        } catch (err) {
            this.$notification(NotificationOptions.error(err));
        }
    }

    async sendAwaitingInsuranceText() {
        try {
            const previewResponse = await axios.get(`/api/patient/${this.patient.id}/preview/AwaitingInsuranceText`)
            const preview = previewResponse.data;
            const h = this.$createElement;
            let messageNodes = [
                h('div', { class: "msg-bubble" }, preview)
            ];
            const confirm = await this.$bvModal.msgBoxConfirm(
                messageNodes,
                {
                    title: 'Confirm Send Text Message',
                    okVariant: 'primary',
                    centered: true,
                    okTitle: "Send",
                }
            );
            if (!confirm) return;

            await axios.post("/api/Patient/SendAwaitingInsuranceText", this.patient);
            this.$notification(NotificationOptions.success("Message Sent"));
        } catch (err) {
            this.$notification(NotificationOptions.error(err));
        }
    }

    //PAP
    protected selectedProgramForPap: Program = new Program();
    protected selectedDrugForPap: Drug = new Drug();
    protected selectedStoreForPap: Store = new Store();

    showPapTextModal() {
        this.selectedProgramForPap = new Program();
        this.selectedDrugForPap = new Drug();
        this.selectedStoreForPap = new Store();
        this.$bvModal.show("SendPapTextModal");
    }

    async sendPapText() {
        const programId = this.selectedProgramForPap?.id;
        const drugSource = this.selectedDrugForPap?.source;
        const packageId = this.selectedDrugForPap?.drugId;
        const storeId = this.selectedStoreForPap?.id;

        try {
            const previewResponse = await axios.get(`/api/patient/${this.patient.id}/preview/PatientAssistanceProgramText`, {
                params: {
                    storeId: storeId > 0 ? storeId : null,
                    programId: programId > 0 ? programId : null
                }
            });
            const preview = previewResponse.data;
            const h = this.$createElement;
            let messageNodes = [
                h('div', { class: "msg-bubble" }, preview)
            ];
            const confirm = await this.$bvModal.msgBoxConfirm(
                messageNodes,
                {
                    title: 'Confirm Send Text Message',
                    okVariant: 'primary',
                    centered: true,
                    okTitle: "Send",
                }
            );
            if (!confirm) return;

            await axios.post("patient/SendPatientAssistanceProgramText", this.patient, {
                params: {
                    storeId: storeId > 0 ? storeId : null,
                    programId: programId > 0 ? programId : null,
                    drugSource,
                    packageId: packageId > 0 ? packageId : null
                },
            });
            this.$notification(NotificationOptions.notificationOptionsPreset("Message Sent!", NotificationOptions.NotificationTypes.success));
        } catch (err) {
            this.$notification(NotificationOptions.error(err));
        }
    }

    //Pharmacy Info Texts
    private storeInfo: Store = new Store();

    async sendPharmacyInfoText() {
        try {
            if (!this.storeInfo.id) {
                this.$notification(NotificationOptions.error("Please select a store"));
                return;
            }
            const previewResponse = await axios.get(`/api/patient/${this.patient.id}/preview/PharmacyInfoText/${this.storeInfo.id}`);
            const preview = previewResponse.data;
            const h = this.$createElement;
            let messageNodes = [
                h('div', { class: "msg-bubble" }, preview)
            ];
            const confirm = await this.$bvModal.msgBoxConfirm(
                messageNodes,
                {
                    title: 'Confirm Send Text Message',
                    okVariant: 'primary',
                    centered: true,
                    okTitle: "Send",
                }
            );
            if (!confirm) return;

            await axios.post(`/api/Patient/${this.patient.id}/SendPharmacyInfoText`, this.storeInfo);
            this.$notification(NotificationOptions.notificationOptionsPreset("Message Sent!", NotificationOptions.NotificationTypes.success));
        } catch (err) {
            this.$notification(NotificationOptions.error(err));
        }
    }

    //IRS Report
    StartIRSReport() {
        this.$bvModal.show("irsReportModal");
    }

    //Rx Transfer
    StartRxTransfer() {
        this.$bvModal.show("rxTransferModal");
    }

    //Bulk External Transfer
    startBulkExternalTransfer() {
        this.$bvModal.show("bulk-external-transfer-modal");
    }

    //Fax to Physician
    protected faxFormTypeRequestEnum = FaxType;

    //COVID Modal
    //private covidPlans: CombinedPlan[] = [];
    //private covidPlan: CombinedPlan = {} as CombinedPlan;
    //private covidStore: Store = {} as Store;
    //private covidDisabled: boolean = false;

    // openCovidModal() {
    //     axios
    //         .get<{ plans: Plan[]; patientPlans: PatientPlan[] }>(
    //             `Insurance/${this.patient.id}`,
    //         )
    //         .then((response) => {
    //             this.covidPlans = response.data.patientPlans
    //                 .filter((pp) => pp.active)
    //                 .map((pp) => {
    //                     return new CombinedPlan({
    //                         patientPlan: new PatientPlan(pp),
    //                         plan: new Plan(
    //                             response.data.plans.find(
    //                                 (p) => p.id == pp.planId,
    //                             ),
    //                         ),
    //                     } as CombinedPlan);
    //                 });

    //             this.covidPlan = this.covidPlans[0];
    //             this.$bvModal.show("createCovidTestScript");
    //         })
    //         .catch((error) => {
    //             console.error("Error while loading the insurance plans", {
    //                 error,
    //                 response: error?.response,
    //             });
    //             this.$notification(NotificationOptions.error(error));
    //         });
    // }

    // storeLabel(object: Store) {
    //     let res = "";
    //     if (object.name) res = object.name;

    //     return res;
    // }

    // createCovidScript() {
    //     this.covidDisabled = true;
    //     if (this.covidPlan.patientPlan?.id && this.covidStore?.id) {
    //         axios
    //             .post(
    //                 `patient/${this.patient.id}/${this.covidStore.id}/${this.covidPlan.patientPlan.id}`,
    //             )
    //             .then((response) => {
    //                 let script = Object.assign(
    //                     new Prescription(),
    //                     response.data,
    //                 ) as Prescription;
    //                 if (script.rxID) {
    //                     this.$router.push({
    //                         name: "PrescriptionDetailsId",
    //                         params: { rxId: script.rxID },
    //                     });
    //                 }
    //             })
    //             .catch((error) => {
    //                 console.error("Error creating Covid Test Script", {
    //                     error,
    //                     response: error?.response,
    //                 });
    //                 this.$notification(NotificationOptions.error(error));
    //             });
    //     }
    // }

    //Payment Methods Modal
    paymentMethodsModal() {
        this.$bvModal.show("PaymentMethodModalMaintenance");
    }

    //New Consultation Modal
    private newConsultationStore: Store = new Store();

    openNewConsultationModal() {
        this.$bvModal.show("newConsultationModal");
    }

    updateConsultationsList() {
        this.$bvModal.hide("newConsultationModal");
        this.$emit("update-consultations");
    }

    //Duplicate Modal
    protected mergeRequestTargetPatient = new Patient();
    protected hideMergeRecentList = true;
    protected mergeRequestNotes = "";

    showDuplicateModal() {
        this.mergeRequestTargetPatient = new Patient();
        this.hideMergeRecentList = true;
        this.mergeRequestNotes = "";
    }

    async addMergeQueue(e: BvModalEvent) {
        e.preventDefault();
        try {

            if (!this.mergeRequestTargetPatient?.id) {
                this.$notification(NotificationOptions.error("Must select a target patient for the merge request"));
                return;
            }

            if (this.patient.id === this.mergeRequestTargetPatient.id) {
                this.$notification(NotificationOptions.error("Source and target patient can't be the same record"));
                return;
            }

            const request = `/patient/mergequeue/${this.patient.id}/${this.mergeRequestTargetPatient.id}`;
            await axios.post(request, null, {
                params: this.mergeRequestNotes ? { notes: this.mergeRequestNotes } : undefined
            });

            this.$notification(NotificationOptions.notificationOptionsPreset("Patient merge request added", NotificationOptions.NotificationTypes.success));

            this.$bvModal.hide(`duplicate-modal`);
        } catch (err) {
            this.$notification(NotificationOptions.error(err));
        }
    }

    //Patient App Modal
    resetPatientAppModal() {
        this.$bvModal.show("ResetPatientAppModal");
    }

    hidePatientAppModal() {
        this.$bvModal.hide("ResetPatientAppModal");
    }

    //MedSync Enrollment Modal
    openMedSyncEnrollmentModal() {
        this.$bvModal.show("med-sync-enrollment-modal");
    }

    onMedSyncEnrollmentCompleted() {
        this.$bvModal.hide("med-sync-enrollment-modal");
        this.$emit("medsync-enrollment-completed");
    }

    //Create Case Modal
    openCreateCaseModal() {
        this.$bvModal.show("patient-actions-create-case-modal");
    }

    onCaseSaved(caseId: number) {
        // Case saved successfully - modal closes itself
    }

    //Old Portal Link
    get hasOldPortal(): boolean {
        return this.patient.createdBy?.indexOf(":") > 0;
    }

    get oldPortalLink(): string {
        if (this.patient.createdBy?.indexOf(":") > 0) {
            const oldPatIds = this.patient.createdBy.split(":");
            return `https://portal.cphrx1.local/Patient/${oldPatIds[0]}/${oldPatIds[1]}`;
        }
        return "";
    }

    //Custom Text Messages
    protected showingCustomTextSubMenu = false;
    protected availableCustomTextTemplates: CustomTextMessageTemplate[] = [];
    protected activeCustomTextTemplate: CustomTextMessageTemplate | null = null;

    //Text Message Templates Configuration
    protected textMessageTemplates: any = null;

    //NPC Text Final Warning Modal
    protected npcTextPreview = "";
    protected npcFinalWarningCountdown = 5;
    private npcFinalWarningInterval: number | null = null;
    private npcFinalWarningResolve: ((value: boolean) => void) | null = null;

    async getAvailableCustomTextTemplates() {
        try {
            const resp = await axios.get<CustomTextMessageTemplate[]>("/CustomTextMessage/available");
            this.availableCustomTextTemplates = resp.data;
        } catch (err) {
            console.error(err);
        }
    }

    async getTextMessageTemplates() {
        try {
            const resp = await axios.get("/api/Configuration/TextMessageTemplates");
            this.textMessageTemplates = resp.data;
        } catch (err) {
            console.error("Failed to load text message templates config:", err);
        }
    }

    get isNpcTextDisabled(): boolean {
        return this.textMessageTemplates?.NPC?.Disabled === true;
    }

    get isRefillTextDisabled(): boolean {
        return this.textMessageTemplates?.Refill?.Disabled === true;
    }

    get isRxRequestDeniedTextDisabled(): boolean {
        return this.textMessageTemplates?.RxRequestDenied?.Disabled === true;
    }

    get isPharmacyInfoTextDisabled(): boolean {
        return this.textMessageTemplates?.PharmacyInfo?.Disabled === true;
    }

    get isAwaitingInsuranceTextDisabled(): boolean {
        return this.textMessageTemplates?.AwaitingInsurance?.Disabled === true;
    }

    get filteredAvailableCustomTextTemplates() {
        return this.availableCustomTextTemplates.filter(template => {
            // If no program restrictions, show to everyone
            if (!template.limitToPrograms.length) return true;

            // Check if patient is assigned to any of the template's allowed programs
            const patientInProgram = template.limitToPrograms.some(program =>
                this.patient.programs?.some(pp => pp.programID === program.id)
            );

            // Check if any prescription is in one of the template's allowed programs
            const prescriptionInProgram = template.limitToPrograms.some(program =>
                this.prescriptions?.some(rx => rx.programID === program.id)
            );

            return patientInProgram || prescriptionInProgram;
        }).toSorted((a, b) => a.name.localeCompare(b.name));
    }

    get hasPV1Permission(): boolean {
        return this.$permissions.some((p: any) =>
            p.permissionCodeName === "Pharmacists/PV1 Queue" ||
            p.permissionCodeName === "Other/View PV1 Queue"
        );
    }

    get hasBulkTransferPermission(): boolean {
        return this.$permissions.some((p: any) =>
            p.permissionCodeName === "Pharmacists/Rx Transfers/Bulk Transfer"
        );
    }

    startCustomTextSend(template: CustomTextMessageTemplate) {
        this.activeCustomTextTemplate = {
            ...template,
            store: new Store(),
            relatedPrescription: new Prescription()
        };
    }

    async sendCustomText(e: BvModalEvent) {
        e.preventDefault();
        try {
            const relatedScript = this.activeCustomTextTemplate!.relatedPrescription;
            const requiresScript = this.activeCustomTextTemplate!.requiresPrescription;

            if (requiresScript && !relatedScript?.rxNumber) {
                this.$notification(NotificationOptions.error("You must select a prescription."));
                return;
            }

            const hasStore = !!this.activeCustomTextTemplate!.store?.id;
            if (!requiresScript && !relatedScript?.rxNumber && !hasStore) {
                this.$notification(NotificationOptions.error("You must select a store or prescription."));
                return;
            }

            const programs = this.activeCustomTextTemplate?.limitToPrograms;
            if (programs?.length && relatedScript?.programID && !programs.some(p => p.id === relatedScript.programID)) {
                let errorMsg = "This text cannot be sent for this prescription due to program limits. ";
                if (programs.length === 1) {
                    errorMsg += `Template limited to ${programs[0].name} program.`;
                } else {
                    errorMsg += `Template limited to these programs: ${programs.map(p => p.name).join(", ")}`;
                }
                this.$notification(NotificationOptions.error(errorMsg));
                return;
            }

            await axios.post(`CustomTextMessage/send/${this.patient.id}`, this.activeCustomTextTemplate);
            this.activeCustomTextTemplate = null;
            this.$notification(NotificationOptions.success("Successfully sent text message to patient"));
        } catch (err) {
            this.$notification(NotificationOptions.error(err));
        }
    }

    startNpcFinalWarningCountdown() {
        this.npcFinalWarningCountdown = 5;
        this.npcFinalWarningInterval = window.setInterval(() => {
            this.npcFinalWarningCountdown--;
            if (this.npcFinalWarningCountdown <= 0) {
                if (this.npcFinalWarningInterval) {
                    clearInterval(this.npcFinalWarningInterval);
                    this.npcFinalWarningInterval = null;
                }
            }
        }, 1000);
    }

    clearNpcFinalWarningCountdown() {
        if (this.npcFinalWarningInterval) {
            clearInterval(this.npcFinalWarningInterval);
            this.npcFinalWarningInterval = null;
        }
        this.npcFinalWarningCountdown = 5;
        if (this.npcFinalWarningResolve) {
            this.npcFinalWarningResolve(false);
            this.npcFinalWarningResolve = null;
        }
    }

    confirmNpcFinalWarning() {
        if (this.npcFinalWarningResolve) {
            this.npcFinalWarningResolve(true);
            this.npcFinalWarningResolve = null;
        }
    }

    async showNpcFinalWarningModal(preview: string): Promise<boolean> {
        this.npcTextPreview = preview;
        return new Promise<boolean>((resolve) => {
            this.npcFinalWarningResolve = resolve;
            this.$bvModal.show('npc-text-final-warning-modal');
        });
    }

    // Awaiting PV1 Status Indication
    protected awaitingPV1: OrderLabelData[] = [];
    protected loadingAwaitingPV1 = false;
    protected errorAwaitingPV1 = "";

    async getAwaitingPV1() {
        try {
            this.errorAwaitingPV1 = "";
            this.loadingAwaitingPV1 = true;
            const response = await axios.get<OrderLabelData[]>("/api/prescription/pv1-queue/", { params: { patientId: this.patient.id } });
            this.awaitingPV1 = response.data.map(i => Object.assign(new OrderLabelData(), i));
        } catch (err) {
            console.error(err);
            this.errorAwaitingPV1 = NotificationOptions.error(err).message;
        } finally {
            this.loadingAwaitingPV1 = false;
        }
    }

    //Available to Order
    protected availableToOrder: Prescription[] = [];
    protected loadingAvailableToOrder = false;
    protected errorAvailableToOrder = "";

    async getAvailableToOrder() {
        try {
            this.errorAvailableToOrder = "";
            this.loadingAvailableToOrder = true;
            const response = await axios.get<Prescription[]>(`/api/prescription/AutoFillAvailableToOrder/${this.patient.id}`);
            this.availableToOrder = response.data
                .map(i => Object.assign(new Prescription(), i))
                .filter(p => p.patientPay != null);
        } catch (err) {
            console.error(err);
            this.errorAvailableToOrder = NotificationOptions.error(err).message;
        } finally {
            this.loadingAvailableToOrder = false;
        }
    }

    //Pending Billing
    protected pendingBilling: Prescription[] = [];
    protected loadingPendingBilling = false;
    protected errorPendingBilling = "";

    async getPendingBilling() {
        try {
            this.errorPendingBilling = "";
            this.loadingPendingBilling = true;
            const response = await axios.get<OrderLabelData[]>("/api/prescription/get-pending-billing/", { params: { patientId: this.patient.id } });
            this.pendingBilling = response.data.map(i => Object.assign(new OrderLabelData(), i));
        } catch (err) {
            console.error(err);
            this.errorPendingBilling = NotificationOptions.error(err).message;
        } finally {
            this.loadingPendingBilling = false;
        }
    }

    //Open Assigned Tasks
    protected openAssignedTasks: UserTask[] = [];
    protected errorOpenAssignedTasks = "";
    protected loadingOpenAssignedTasks = false;
    protected dispenseErrorLabel = "";

    async getOpenAssignedTasks() {
        try {
            this.errorOpenAssignedTasks = "";
            this.loadingOpenAssignedTasks = true;
            const response = await axios.get<{ tasks: UserTask[] }>("/api/Task/", {
                params: {
                    assignedToPatientId: this.patient.id,
                    status: "active"
                }
            });
            this.openAssignedTasks = response.data.tasks.map(i => Object.assign(new UserTask(), i));
        } catch (err) {
            console.error(err);
            this.errorOpenAssignedTasks = NotificationOptions.error(err).message;
        } finally {
            this.loadingOpenAssignedTasks = false;
        }
    }

    async fetchDispenseErrorLabel() {
        try {
            const resp = await this.$http.get("/Configuration/DispenseErrorLabel");
            this.dispenseErrorLabel = resp.data?.trim();
        } catch {
            this.dispenseErrorLabel = "Error";
            //ignore
        }
    }

    // Public method to refresh all status indicators after prescription changes
    public refreshStatusIndicators() {
        this.getAwaitingPV1();
        this.getAvailableToOrder();
        this.getPendingBilling();
    }
}

</script>

<style>
.actions-popover {
    min-width: 200px !important;
    width: 70vw !important;
    max-width: 450px !important;
}

.actions-popover.multi-col {
    min-width: 300px !important;
    width: 70vw !important;
    max-width: 550px !important;
}

.actions-popover.sub {
    min-width: 100px !important;
    max-width: 250px !important;
    background: rgba(255, 255, 255, .85) !important;
}

.actions-popover.multi-col .popover-body>div {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(min(100%, 250px), 1fr));
    gap: 10px;
}

.actions-popover h6 {
    margin: 0;
    padding-left: 5px;
    padding-bottom: 3px;
    border-bottom: 3px solid rgba(0, 0, 0, .05);
    color: rgba(0, 0, 0, .8);
}

.actions-popover ul {
    list-style: none;
    padding: 0;
    padding-left: 0 !important;
    margin: 0;
}

.actions-popover li a.dropdown-item {
    padding: 8px 5px;
    margin: 0;
    font-size: 1em;
    font-weight: 500;
}

.actions-popover li.open a.dropdown-item {
    background: #e9ecef;
    color: black;
}

.actions-popover.sub li a.dropdown-item {
    padding: 3px 5px;
    margin: 0;
    font-size: 1em;
    font-weight: 500;
}
</style>

<style scoped>
.status-indication {
    font-size: 1.1em;
    gap: 3px;
}

.status-indication ::v-deep(button) {
    font-variant-numeric: tabular-nums;
    font-weight: 500;
}

.rxId {
    font-variant-numeric: tabular-nums;
    font-weight: 500;
}
</style>
